import { Tab, Tabs, Typography, Box } from '@mui/material'
import { useState } from 'react'
import { TabDisplay } from '../../Components/TabDisplay'
import { DateRangeList } from './DateRangeList'
import { ServicesList } from './Service'
import { ExportPeriodList } from './MsdsExportPeriod'
import { FileTypeList } from './FileType'
import { ProgramsList } from './Program'
import { ServiceProviderList } from './ServiceProviderList'
import { FederalPovertyLevelList } from './FederalPovertyLevelList'

export function ApplicationSettings (): JSX.Element {
  const [value, valueChange] = useState(0)
  return <Box>
    <Typography variant="h3" data-testid='page-header'>Application Settings</Typography>
    <Tabs value={value}
      data-testid='tabs'
      onChange={(e, val) => { valueChange(val) }}
      aria-label="Application Settings Tabs"
      textColor="secondary"
      indicatorColor="secondary"
      variant="scrollable"
      scrollButtons="auto"
    >
      <Tab label="Time Spans" value={0} data-testid='time-spans' />
      <Tab label="FPL Years" value={6} data-testid='fpl' />
      <Tab label="Service Providers" value={5} data-testid='service-providers' />
      <Tab label="Services" value={1} data-testid='services' />
      <Tab label="Programs" value={2} data-testid='programs' />
      <Tab label="MSDS Export Periods" value={3} data-testid='msds-export-periods' />
      <Tab label="Document Types" value={4} data-testid='document-types' />
    </Tabs>
    <TabDisplay
      index={0}
      value={value}
    >
      <DateRangeList />
    </TabDisplay>
    <TabDisplay
      index={1}
      value={value}
    >
      <ServicesList />
    </TabDisplay>
    <TabDisplay
      index={2}
      value={value}
    >
      <ProgramsList />
    </TabDisplay>
    <TabDisplay
      index={3}
      value={value}
    >
      <ExportPeriodList />
    </TabDisplay>
    <TabDisplay
      index={4}
      value={value}
    >
      <FileTypeList />
    </TabDisplay>
    <TabDisplay
      index={5}
      value={value}
    >
      <ServiceProviderList />
    </TabDisplay>
    <TabDisplay
      index={6}
      value={value}
    >
      <FederalPovertyLevelList />
    </TabDisplay>

  </Box>
}
